import { render } from "./EmpresaEdit.vue?vue&type=template&id=0e502bf1"
import script from "./EmpresaEdit.vue?vue&type=script&lang=js"
export * from "./EmpresaEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__